import React, { useState, useEffect, useRef } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import classNames from "classnames"
import currentUser from "helpers/currentUser"
import { useHistory } from "react-router-dom"

let TypeaheadField = require("react-typeahead").Typeahead

const Finder = (props) => {
	const userAgent = navigator?.userAgent?.toLowerCase()
	const user = currentUser()
	const [isSuggestionOpen, setIsSuggestionOpen] = useState(false)
	const [options, setOptions] = useState([])
	const [all, setAll] = useState([])
	const ref = useRef(null)
	const history = useHistory()

	useEffect(() => {
		function handleKeyPress(event) {
			if (userAgent.indexOf("mac") !== -1) {
				// mac
				if (event.metaKey && event.key === "k") {
					ref?.current?.focus()
					event.preventDefault()
				}
			} else {
				// Windows
				if (event.ctrlKey && event.key === "k") {
					ref?.current?.focus()
					event.preventDefault()
				}
			}
		}

		document.addEventListener("keydown", handleKeyPress)

		return () => {
			//document.removeEventListener("keydown", handleKeyPress)
		}
	}, [])

	useEffect(() => {
		let modules = []
		_.forEach(props.payload.modules, (m) => {
			if (m.is_parent && !m.path) return
			if (user.modules.includes(m.id) || user.modules[0] === "*") {
				modules.push({
					id: m.id,
					label: `${m.name} - ${m.path}`,
					path: m.path,
					name: m.name,
					type: "module",
				})
			}
		})
		setAll(modules)
	}, [props.payload.modules])

	const buildOptions = (query) => {
		let ret = []
		let modules = []
		let lots = []
		let v = query.target.value?.toLowerCase()
		// Make sure they don't have to hit down arrow to get the first result highlighted
		if (ref.current.state.selectionIndex === null) {
			ref.current.state.selectionIndex = 0
		}
		_.forEach(all, (m) => {
			if (m.label?.toLowerCase()?.includes(v)) {
				modules.push(m)
			}
		})
		_.forEach(props.payload.exec.lots, (l) => {
			if (l.address?.toLowerCase()?.includes(v)) {
				let f = {
					id: l.id,
					label: `${l.address}`,
					type: "lot",
					path: `/admin/lot-management/${l.id}`,
				}
				lots.push(f)
			}
		})

		// Add headers and organize results in buckets
		if (modules.length > 0) {
			ret.push({ id: "modules_header", label: "Modules", path: "" })
			ret = [...ret, ...modules]
		}

		if (lots.length > 0) {
			ret.push({ id: "lots_header", label: "Lots", path: "" })
			ret = [...ret, ...lots]
		}
		setOptions(ret)
	}

	let resultsClasses = classNames("", {
		"form__typeaheadCont--isOpen": isSuggestionOpen,
		"form__typeaheadCont--isClosed": !isSuggestionOpen,
	})

	let metaKey = "Ctrl"
	if (userAgent.indexOf("mac") !== -1) {
		metaKey = "⌘"
	}

	return (
		<div className="Finder relative">
			<div>
				<TypeaheadField
					customClasses={{
						//input: "form__input",
						results: resultsClasses,
						listItem: "form__typeaheadItem",
					}}
					// Add custom renderer for list items
					customListComponent={(props, isHighlighted) => {
						// Check if it's a header
						let items = []
						_.forEach(props.options, (v, k) => {
							const isHeader = v.id === "modules_header" || v.id === "lots_header"
							items.push(
								<li
									className={classNames(`hover:bg-blue-500 hover:text-white cursor-pointer`, {
										"!bg-blue !text-white cursor-not-allowed": isHeader || props.selectionIndex === k
									})}
									key={v.id}
									onMouseDown={() => {
										if(isHeader) return
										props.onOptionSelected(v)
										history.push(v.path)
										setIsSuggestionOpen(false)
										ref.current.state.selectionIndex = 0
										
									}}
									>
									{v.label}
								</li>
							)
						})
						return (
							<ul className={`typeahead-selector ${isSuggestionOpen ? "block" : "hidden"}`}>{items}</ul>
						)
					}}
					filterOption={(typeValue, opt) => {
						// Always include headers
						if (opt.id === "modules_header" || opt.id === "lots_header") {
							return true
						}
						// For non-headers, use the default filtering behavior
						let check = opt.label.toLowerCase().includes(typeValue.toLowerCase())
						return check ? true : false
					}}
					displayOption={"label"}
					options={options}
					onKeyUp={(query) => {
						buildOptions(query)
						setIsSuggestionOpen(true)
					}}
					/* onChange={(q) => {
						let v = q.target.value
						//console.log(v)
						//setIsSuggestionOpen(true)
					}} */
					//value={this.props.value}
					onFocus={() => {
						setIsSuggestionOpen(true)
					}}
					onBlur={() => {
						setIsSuggestionOpen(false)
						ref.current.state.selectionIndex = 0
					}}
					placeholder={"Find.."}
					onOptionSelected={(v) => {
						history.push(v.path)
						ref.current.setEntryText("")
						ref.current.state.selectionIndex = 0
					}}
					maxVisible={15}
					//inputProps={{ autoComplete: "sale-street-address" }}
					ref={ref}
				/>
				<div className="absolute right-0 top-0 2xl:flex items-center h-full pr-1 hidden">
					<div className="bg-slate-900 text-white py-1 px-2 rounded-lg text-[10px] font-bold">{metaKey}</div>
					<div className="font-bold text-xs px-[2px]">+</div>
					<div className="bg-slate-900 text-white py-1 px-2 rounded-lg text-[10px] font-bold">K</div>
				</div>
			</div>
		</div>
	)
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(Finder)
